import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import ChevronRight from '@material-ui/icons/ChevronRight'
import Phone from '@material-ui/icons/Phone'
import CheckCircle from '@material-ui/icons/CheckCircle'
import { translate } from 'react-i18next'
import Footer from './Footer'

const styles = theme => ({
    image: {
        width: 100,
        height: 100,
        borderRadius: 4,
    },
    titleWithAvatar: {
        display: 'flex',
        alignItems: 'center'
    },
    socialInfo: {
        color: '#3b5998',
        marginRight: 8,
    },
    listItemNoPadding: {
        padding: 0
    },
    addressMap: {
        width: '100%'
    },
    greyListItem: {
        backgroundColor: '#f5f5f5'
    },
    videowrapper: {
        float: 'none',
        clear: 'both',
        width: '100%',
        position: 'relative',
        paddingBottom: '56.25%',
        // paddingTop: '25px',
        height: 0
    },
    iframeInVideowrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
    },
    iconWithPrimaryColor: {
        color: '#00BFA5'
    }
})
 
const ProfileDetail = ({ classes, profile, t, i18n }) => { 
    let width = (window.innerWidth > 0) ? window.innerWidth : 600

    function mapsSelector() {
        if /* if we're on iOS, open in Apple Maps */
          ((navigator.platform.indexOf("iPhone") != -1) || 
           (navigator.platform.indexOf("iPod") != -1) || 
           (navigator.platform.indexOf("iPad") != -1))
          window.open(`maps://maps.google.com/maps?q=${profile.address}`);
      
        else /* else use Google */
          window.open(`https://maps.google.com/maps?q=${profile.address}`);
    }

    return (
        <div>
            <List style={{ paddingBottom: 0 }}>
                {profile.youtubeID && (<ListItem divider={true} className={classes.greyListItem}></ListItem>)}
                {profile.youtubeID && (<ListItem divider={true} className={classes.listItemNoPadding}>
                    <div className={classes.videowrapper}>
                        <iframe width="560" height="349" className={classes.iframeInVideowrapper} src={`https://www.youtube.com/embed/${profile.youtubeID}`} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
                    </div>
                </ListItem>)}
                <ListItem divider={true}>
                    <Grid container>
                        <Grid item xs={12}>
                                <div className={classes.titleWithAvatar}>
                                    <Typography variant="title" color="default">
                                        {profile.displayName}
                                    </Typography>
                                    <Avatar alt="Remy Sharp" src={profile.photoURL} style={{ marginLeft: 'auto'}}/>
                                </div>
                                <Typography variant="body2" color="primary">
                                    {profile.categories ? Object.keys(profile.categories).map(item => t(`alias:${item}`)).join(', ') : ''}
                                </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body2" color="textSecondary">
                                {profile.about}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
                {profile.address && (<ListItem divider={true} className={classes.greyListItem}></ListItem>)}
                {profile.address && (<ListItem divider={true} className={classes.listItemNoPadding} onClick={mapsSelector}>
                    <img src={`https://maps.googleapis.com/maps/api/staticmap?&size=${width}x200&maptype=roadmap&markers=${profile.address}&language=en&scale=2&key=AIzaSyD_O56EYKD_pjz6TLyY_AHFnpT3ydC61dU`} className={classes.addressMap} />
                </ListItem>)}
                {profile.address && (<ListItem divider={true} onClick={mapsSelector}>
                    <Typography variant="subheading" color="textSecondary">
                        {profile.address}
                    </Typography>
                    <ListItemIcon style={{marginLeft: 'auto'}}>
                        <ChevronRight />
                    </ListItemIcon>
                </ListItem>)}
                {profile.phoneNum && (<ListItem divider={true} className={classes.greyListItem}></ListItem>)}
                {profile.phoneNum && (<a href={`tel:${profile.phoneNum}`} style={{textDecoration: 'none', color: 'rgba(0, 0, 0, 0.54)'}}>
                    <ListItem divider={true} >
                        <ListItemIcon>
                            <Phone className={classes.iconWithPrimaryColor}/>
                        </ListItemIcon>
                        <Typography variant="subheading" color="textSecondary">
                            {profile.phoneNum}
                        </Typography>
                        <ListItemIcon style={{marginLeft: 'auto'}}>
                            <ChevronRight />
                        </ListItemIcon>
                    </ListItem>
                </a>)}
                {/* <ListItem divider={true}>
                    <ListItemIcon>
                        <CheckCircle className={classes.iconWithPrimaryColor}/>
                    </ListItemIcon>
                    <Typography variant="subheading" color="textSecondary" noWrap style={{overflowX: 'auto', textOverflow: 'inherit'}}>
                        {`提供到府服務, 外送, 遠端工作, 遠端教學`}
                    </Typography>
                </ListItem> */}
                <ListItem divider={true} className={classes.greyListItem}></ListItem>
                <ListItem style={{ backgroundColor: '#009688' }}>
                    <Footer/>
                </ListItem>
            </List>
        </div>
    )
}

export default translate(['translations', 'alias'])(withStyles(styles)(ProfileDetail))


// WEBPACK FOOTER //
// ./src/components/ProfileDetail.js